import { render, staticRenderFns } from "./ImageInput.vue?vue&type=template&id=21284b16&scoped=true&"
import script from "./ImageInput.vue?vue&type=script&lang=js&"
export * from "./ImageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21284b16",
  null
  
)

export default component.exports